import GridComponent from '../../../component/grid/GridComponent.component';
import Card from '../../../component/card/Card.component';
import Grid from '@material-ui/core/Grid';
import ButtonLink from '../../../component/buttton/ButtonLink.component';
import Router from './Router.container';
import { Container } from '../../../component/container/Container';
import { BiChevronRight } from 'react-icons/bi';

export default function NotificationComponent() {

    return (
        <Container margin="0px 0px 40px 0px">
            <GridComponent spacing={2}>
                <Grid item>
                    <ButtonLink title="Grupos" link='/comunicado-corporativo/grupos' size='medium' icon={<BiChevronRight />} />
                </Grid>
                <Grid item>
                    <ButtonLink title="Colaboradores" link='/comunicado-corporativo/grupos/colaboradores' size='medium' icon={<BiChevronRight />} />
                </Grid>
                <Grid item>
                    <ButtonLink title="voltar" link='/comunicado-corporativo' variant='outlined' size='medium' />
                </Grid>
            </GridComponent>

            <Card color="#fbfbfb" padding={'10px 20px'} margin='20px 0px 0px 0px' >
                <Grid item sm={12}>
                    <Router />
                </Grid>
            </Card>
        </Container>
    );
}
